import { render, staticRenderFns } from "./FormTwoFACode.vue?vue&type=template&id=26082e65&scoped=true"
import script from "./FormTwoFACode.vue?vue&type=script&lang=js"
export * from "./FormTwoFACode.vue?vue&type=script&lang=js"
import style0 from "./FormTwoFACode.vue?vue&type=style&index=0&id=26082e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26082e65",
  null
  
)

export default component.exports